export enum ETransactionDirection {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export enum ETransactionUiType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  BUY = 'BUY',
  SELL = 'SELL',
  FEE = 'FEE',
  DIVIDEND = 'DIVIDEND',
  OPF_MANAGEMENT_FEE_REFUND = 'OPF_MANAGEMENT_FEE_REFUND',
  ROUNDING_RETURN = 'ROUNDING_RETURN',
  FX_TRANSACTION = 'FX_TRANSACTION',
  CORPORATE_ACTION = 'CORPORATE_ACTION',
}

export interface ITransactionPortfolio {
  portfolioId: number;
  name: string;
  dip: boolean;
  accessible: boolean;
}

export enum EInstrumentKind {
  MUTUAL_FUND_UNITS = 'MUTUAL_FUND_UNITS',
  INVESTMENT_SHARES = 'INVESTMENT_SHARES',
}

export interface ITransactionInstrument {
  instrumentId: number;
  isin: string;
  currencyCode: string;
  cash: boolean;
  name: string;
  instrumentKind: EInstrumentKind | null;
}

export interface ITransaction {
  transactionId: string;
  portfolio: ITransactionPortfolio;
  instrument: ITransactionInstrument;
  direction: ETransactionDirection;
  uiType: ETransactionUiType;
  quantity: number;
  price: number;
  amount: number;
  transactionTimestamp: string;
  description: string;
  fxPortfolioTransactionId: number;
  vat: number;
  type: ETransactionType | null;
  fxCurrencyPair: string | null;
  corporateAction: ICorporateAction | null;
}

export enum ECorporateActionType {
  STOCK_SPLIT = 'STOCK_SPLIT',
}


export interface ICorporateAction {
  actionType: ECorporateActionType;
  typeLabel: string;
  uiLabel: string;
  ratioFrom: number;
  ratioTo: number;
  quantityBefore: number;
  quantityAfter: number;
  priceBefore: number;
  priceAfter: number;
  description: string;
  instrumentKind: EInstrumentKind | null;
  effectiveDate: string;

}

export interface ITransactionDetail {
  transactionId: string;
  name: string;
  instrumentName: string;
  transactionTimestamp: string;
  isin: string;
  price: number;
  amount: number;
  instrumentKind: string | null;
  uiType: ETransactionUiType;
  type: ETransactionType | null;
  description: string;
  quantity: number;
  currencyCode: string;
  fxCurrencyPair: string | null;
  direction: ETransactionDirection;
  vat: number;
  corporateAction: ICorporateAction | null;
}

export enum ETransactionType {
  ORDER = 'ORDER',
  MONEY = 'MONEY',
  FEE = 'FEE',
  OPF_MANAGEMENT_FEE_REFUND = 'OPF_MANAGEMENT_FEE_REFUND',
  ROUNDING_RETURN = 'ROUNDING_RETURN',
  CORPORATE_ACTION = 'CORPORATE_ACTION',
}

export interface ITransactionsPage {
  content: ITransaction[];
  totalCount: number;
}

export interface ITransactionsQueryParams {
  portfolioIds?: number[];
  transactionTimestampFrom?: string;
  transactionTimestampTo?: string;
  type?: ETransactionUiType[];
  page?: number;
  size?: number;
  query?: string;
}

export interface IAllInvestmentsListItem {
  name: string,
  portfolioId: number,
  isLiquidated: boolean,
  depositExists: boolean,
}

export interface ITransactionsState {
  transactions: ITransaction[];
  transactionsForSearchCount: number | null;
  totalCount: number | null;
  selectedTransaction: ITransaction | null;
}

export enum ETransactionFilterPeriod {
  FROM_BEGINNING = 'FROM_BEGINNING',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  FROM_YEAR_START = 'FROM_YEAR_START',
  LAST_YEAR = 'LAST_YEAR',
  LAST_5_YEARS = 'LAST_5_YEARS',
}

export interface ITransactionFilter {
  period: ETransactionFilterPeriod;
  transactionTypes: ETransactionUiType[];
  selectedInvestmentsIds: number[];
  query?: string;
}

export interface ITransactionOptions {
  investmentId: number | null;
  filterOptions: ITransactionFilter;
}

export interface ITransactionGroup {
  month: string;
  year: number;
  transactions: ITransaction[];
}

export interface ExportTransactionsIn {
  clientId : string | number,
  optDateFrom: string,
  optDateTo: string,
  transactionTypes: ETransactionUiType[],
}
export interface GenerateDocumentLinkOut {
  filename: string,
  link: string,
}
